<template>
    <div>
        <el-row>
            <el-col :span="4"><div class="grid-content"></div></el-col>
            <el-col :span="16">

                <div class="title">
                    <h1>Value‑based model of user interaction design for virtual museum</h1>
                </div>

            </el-col>
            <el-col :span="4"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="8"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project13_1.jpg">
                </div>
            </el-col>
            <el-col :span="8"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="20">
                <div class="abstract">
                    With the development of digital technology and the popularity of human-centered concepts in museum exhibition design,
                    the user experience of VR (virtual reality)-based museum exhibition (VRME) is gradually being emphasized. There are still
                    many problems that need to be solved in the integration of technology and interaction in today’s VRME design. However, the
                    existing museum exhibition design framework does not combine the characteristics of virtual reality technology to solve the
                    problems unique to VRME in a targeted manner. Based on the traditional user experience framework, this paper summarizes
                    the three levels of user experience (LoUX) in a museum exhibition and proposes the unique “creation level” experience of
                    VRME, which constitutes the closed-loop of the VRME experience. Then, this paper analyzes the relevant researches in
                    recent years through a literature review and summarizes the trends of technology application and the diferent interaction
                    problems arising from each LoUX. Based on the results of literature analysis, this paper proposes a “rose model” of VRME.
                    This model summarizes the relationship between exhibition technology, sensory types, LoUX, and human-exhibition interaction factors, which has certain guiding signifcance for VRME desig
                    <div class="paper_published">
                      <br><br>Ning Zou, Qing Gong, Jiangping Zhou, Pengrui Chen, Wenqi Kong, and Chunlei Chai. 2021. ‘Value-Based Model of User Interaction Design for Virtual Museum’. CCF Transactions on Pervasive Computing and Interaction 3(2):112–28. doi: 10.1007/s42486-021-00061-7.
                    </div>
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project13_2.jpg">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Four levels of user experience in VRME
                </div>
                <div class="text">

                    In the process of the development of VRME experience
                    design research, museum exhibition has gradually formed
                    three important levels of user experience: artifact level,
                    behavior level, and spiritual level. Thanks to the application
                    of virtual reality technology in museum exhibition, a fourth
                    level of user experience has gradually emerged in addition
                    to these three levels: the creation level. At the same time,
                    the three levels of artifact layer, behavior layer and spiritual
                    layer have also been upgraded with the empowerment of
                    virtual reality technology. These four experience levels are
                    not only the audience’s experience of viewing the exhibition but also the expression level of the museum exhibition
                    information
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Study selection and analysis
                </div>
                <div class="text">
                    The following section shows the process that how literature
                    related to VRME be found and how the result is fltered.
                    Then, the classifcation and the analysis of studies through
                    three elements of museum virtual exhibition is conducted.
                    The keywords “museum virtual exhibition” were searched
                    in WoS, ScienceDirect and IEEE electronic databases, and
                    most of the literature was fltered out according to the type
                    of literature and access rights. Then the remaining literature
                    was skimmed through to flter out some related literature
                    that only involved web technology but not virtual reality
                    technology, and the remaining literature was selected from
                    research papers that involved specifc design practice projects. Finally, a total of 42 studies were screened.
                    <br><br>The literature obtained from the screening was reviewed and
                    the cases of VRME mentioned in each literature were analyzed according to the following criteria.
                    <br><br>1. LoUX: the experience levels involved in VRME, including the artifact level (cases mentioning exhibit appearance exhibition), the behavior level (cases mentioning
                    exhibit function simulation or activity simulation), the
                    spiritual level (cases mentioning atmosphere rendering
                    and connotation construction) and the creation level
                    (cases mentioning association and creation sharing).
                    <br><br>  2. HEIF: interaction factors common to VRME design.
                    <br><br>  a. Filter keywords: Combine the museum exhibition experience user test dimensions proposed by Lee et al. (2020)
                    and the human exhibition interaction factors proposed by
                    Wang and Xia (2019), with the types of learning behavior
                    proposed by Ahmad et al. (2014), HEIFs are summarized:
                    <br><br>   – Learning: Learning is the most important function of
                    museums. There are three main types of learning in
                    museum exhibitions: cognitive learning, empathic learning, and social learning. Keywords like learning, perception, concentration, etc. are all considered as mentioning
                    the factor of the learning.
                    <br><br>    – Emotion: refers to the immersion and aesthetic experience of the audience during the exhibition viewing process. Keywords like emotional, emotion, enjoyment,
                    enjoyable, and satisfaction are all considered as mentioning the factor of emotion.
                    <br><br>    – Ease of use: refers to the usefulness, fault tolerance,
                    robustness, etc. of the system. Keywords like the ease
                    of use and usefulness are considered as mentioning the
                    system’s ease of use.
                    <br><br>    – Behavior intention: refers to the user’s tendency to visit
                    and consumer behavior, etc. during the exhibition viewing process. Keywords like intention, behavior intention,
                    tendency, etc. are all considered as mentioning the factor
                    of behavioral intention.
                    <br><br>    b. Review Standards: The above keywords should appear
                    in the “research purpose”, “evaluation” or “Research Methods” section, but not in the “background”, “introduction”,
                    “literature review” or “references” section. The context and
                    meaning of the studies that meet the above standards will be
                    further judged. At the same time, read and judge the studies
                    that do not mention those keywords but are suspected to see
                    if t any studies also meet the above standards.
                </div>
            </el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project13_3.jpg">
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="20">
                <div class="picture">
                    <img src="../assets/project13_4.png">
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/project13_5.jpg">
                    <img src="../assets/project13_6.jpg">
                    <img src="../assets/project13_7.jpg">
                    <img src="../assets/project13_8.jpg">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Results
                </div>
                <div class="text">
                    Through literature review, it is found that there are some
                    connections between the four LoUX. Analyzing the relationship between LoUX, and HEIF, we can obtain the model in
                    Fig. 9, which is called the “rose model” because of its roselike shape. This model summarizes the connection between
                    exhibition technology, sensory types, LoUX and HEIF in
                    VRME.
                   <br><br> As shown in Fig. 10, the model is broken down into four
                    parts: (a), (b), (c), (d). (a) represents the virtual exhibition
                    technology at the center, which will serve as the core and foundation of the whole system because of its immersion,
                    multi-perception, interactivity and conceptualization features that traditional exhibition methods do not possess,
                    creating a diferent sensory experience and interactive factors from traditional museum exhibition.
                    <br><br>  Part (b) shows the visual, auditory and kinesthetic sensory types and the relationship between them. According
                    to the analysis above, visual experience is involved in all
                    LoUX and dominates in all of them, so the graph representing visual is a complete circle evenly distributed on the four
                    LoUX. However, auditory experience is mainly highlighted
                    in the process of transformation from the behavior level to
                    the spiritual level, and plays a weaker role in the creation
                    level. The graph representing auditory is an irregular bump
                    that gradually rises from the artifact level and falls back
                    in the spiritual level adn the highest point is located in the
                    middle of the behavior and spiritual level. The graph representing the kinesthetic experience is similar to the auditory
                    one, but in a slightly diferent position, because according
                    to the analysis results, the stronger role of kinesthesia is in the behavior, spiritual and creation levels, mainly in the process of transformation from the spiritual layer to the creation level.
                    <br><br>Part (c) shows the relationship between the four LoUX.
                    The relationship between the four LoUX is exactly the same
                    as shown in Fig. 1 and has been explained above. Here they
                    are rearranged on a circle for the sake of the appearance of
                    the model.
                    <br><br> Part (d) demonstrates a variety of the HEIF covered
                    above, where cognitive, social, and empathic learning are
                    diferent learning types. More cognitive learning occurs
                    during the transformation of the artifact level to the behavior level, more empathic learning occurs during the transformation of the behavior level to the spiritual level, and
                    social learning occurs mainly during the transformation of
                    the spiritual level to the creation level and during the feedback from the creation level to the artifact level. The graphs
                    of all three are therefore irregularly raised and have diferent distributions of the highest point positions. The graph
                    for emotion is a complete circle with an irregular bump at
                    the highest point corresponding to the artifact level, which
                    indicates that emotion is evident in all four LoUX, but the
                    artifact level tends to be the main LoUX that generates emotion. Behavior intention and ease of use factors are similar
                    in graphical form, with more behavior intention such as user
                    consumption and social sharing being evident in the process
                    of transforming the spiritual level to the creation level, while
                    the behavior level will generate more ease of use issues due
                    to its own characteristics.
                    <br><br> In summary, in this model, diferent sensory types and
                    HEIF have spatial correspondence with the four LoUX. If
                    the graph has a bump in the position of a certain experience
                    level, it means that this sensory type plays a greater role in
                    the transformation process between certain experience levels
                    or certain experience levels itself, or the transformation process between certain experience levels or certain experience
                    levels itself can produce a certain HEIF more obviously.
                    <br><br>  When using this model as a design reference, you can
                    select the LoUX needed for the project and observe the corresponding sensory types and HEIF from the diagram. For
                    example, if you need to design for the behavior level, you
                    can intercept the behavior level and its corresponding elements as in Fig. 11 to obtain the following information: In
                    the design of the behavior level, you need to try to ensure the
                    three sensory types of visual, kinesthetic and auditory, and
                    consider both cognitive and empathic learning types, and
                    if appropriate, you need to conduct ease of use tests. More insight can be gained if the interception is expanded with
                    the behavior level as the center (Fig. 12): the transformation process from the artifact level to the behavior level and
                    the behavior level to the spiritual level is considered in the
                    design solution. The artifact level can support the experience
                    of the behavior level, and trying to transform toward the
                    spiritual level can enrich the experience.
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="20">
                <div class="sub-title">
                    Discussion
                </div>
                <div class="text">
                    From the perspective of museum virtual exhibition technology, this paper examines the studies on museum virtual
                    exhibitions in recent years and discovers that the three main
                    elements of museum virtual exhibitions are exhibition technology, EVMs, and IEs. In the process of literature review, it
                    is found that the research hotspots on exhibition technology
                    have gradually tended to more virtual technologies such as
                    VR in the past few years. But the research heat of MR and
                    other technologies have also risen rapidly in recent years,
                    indicating that research in this feld is gradually beginning
                    to pay attention to how to integrate real exhibits or real environment with virtual technology, instead of just confning to
                    absolute virtual museums. Since the birth of New Museology, no matter how the technology develops, attention to the
                    exhibition experience of the audience has only increased.
                    Focusing on a good exhibition experience is also one of the
                    important diferences between modern museums and traditional museums. Finally, this paper proposes a virtual exhibition design framework for museums. Through this framework, one can quickly grasp the composition of a museum’s
                    virtual exhibition system. This framework helps researchers
                    to deeply understand the connotation of VRME.
                  <br><br>  According to this framework, we can also get some
                    insights into the design of future VRME

                    <br><br>  Facilitate the LoUX shift to the creation level
                    <br><br>  The creation level is an important experience level for future VRME, and the formation of the creation level experience relies on the step-by-step support of the artifact level, the behavior level, and the spiritual level.
                    <br><br>      In short, there are two main steps to improve the creation level of experience: the first is to improve the experience of the artifact level, the behavior level, and the spiritual level; the second is to facilitate the transformation of the artifact level experience to the behavior level, the spiritual level, and the creation level experience.
                    <br><br>   From the results of the literature review, we can find that most VRME cases at this stage focus on the research of the artifact level experience, and there are relatively few studies related to the behavior, spiritual, and creation level experiences. Future VRME research can deepen the behavior and spiritual level experiences more, and promote the transformation of the experience level to the creation level by enriching the sensory types and optimizing each HEIF.
                    <br><br> Enriching the types of senses involved in VRME
                    <br><br>   According to different theories, there are many human senses such as visual, auditory, olfactory, gustatory, kinesthetic, tactile, etc. At present, only visual, auditory, kinesthetic, and tactile senses are widely used in VRME, among which visual and auditory senses still occupy the main position.
                    <br><br>   Future VRME research needs to optimize the kinesthetic and kinesthetic-based haptic senses in addition to the visual and auditory experience. Besides, increasing the experience of other sensory types such as smell, heat, and cold will also be a major innovation for VRME interaction. When the sensory types are enriched, the concept of "synesthesia" can be used to create a richer multimodal sensory experience.
                    <br><br>   Inspiring audience’s social and empathic learning
                    <br><br>   The audience's learning type in the museum virtual exhibition is mainly cognitive learning, supplemented by social and affective learning. The museum is a public and thematic scene, which is an ideal place for social and affective learning. This distinguishes the museum from classrooms or other educational scenes. Therefore, how to use exhibition technology to stimulate the audience's social and affective learning types will be a topic worthy of research in the future.
                    <br><br>   Virtual reality technologies will hinder the interaction between people to a certain extent, so in order to promote social learning, when applying VR technology applications, we can use device networking to try multi-person collaboration. When using AR or MR technology, we can create a communication context between people through projection or other ways to share the screen. In the development of exhibition content, it is possible to increase two-person or multi-person cooperation games or give the audience the chance to share through social platforms. The principle is encouraging the audience to put themselves in a social environment when viewing the exhibition.
                    <br><br>   In a museum exhibition with strong themes, affective learning can be used to deepen the audience’s impression of the exhibition theme. The key to realizing empathic learning lies in the presentation of content, which needs to strengthen the rendering of the theme. On the one hand, use narrative methods to tell the story. On the other hand, create the atmosphere through high-immersion exhibition technology like VR technology.
                    <br><br> 	Keep moderate immersion and focus on aesthetic experience
                    <br><br>  Immersion is an important emotional experience that needs to be paid attention to when applying virtual reality technologies in museum virtual exhibitions. Especially when AR and MR technologies are limited by technical characteristics, which caused the immersion created is often inferior to VR technology, more attention needs to be paid to the immersive experience. At the same time, it is necessary to keep the immersion to an appropriate level to avoid excessively high immersion, which causes users to have negative emotions. In the future museum virtual exhibition design, no matter what technology is used, immersion is required as an important design goal. The audience’s immersive experience needs to be verified in the user test phase.
                    <br><br>   Besides, if the exhibition content involves works of art or the exhibition content will occupy most of the audience's visual channels, attention needs to be paid to the audience's aesthetic experience. The artwork itself has extremely high viewing value and will bring a good aesthetic experience. When use virtual exhibition technology to explain the art exhibits, it is necessary to ensure that the original aesthetic experience is not damaged as much as possible and try to optimize the aesthetic experience. A visual image-based exhibition such as scene simulation also needs to pay attention to whether the image is beautiful and whether it can bring good visual enjoyment to the audience. If an image-centric virtual exhibition cannot bring the audience a good visual experience, it will greatly destroy the overall viewing experience.
                    <br><br>  Immersion and aesthetic experience together affect the emotional experience of the audience when viewing the exhibition, and the emotional experience will affect the audience's visit and consumption behavior tendency together with the learning method. Therefore, in the future museum virtual exhibition design, it is necessary to avoid focusing on improving technical functions while ignoring the emotional experience at the interactive level. We should use technology but shouldn’t be limited by technology.

                    <br><br>  <br><br>   For more information, please go for the published paper.
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Project7"
    }
</script>

<style scoped>
    .paper_published{
        font-weight: 400;
        border-bottom: 1px solid black;
    }
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>